import { createContext, useContext } from "react"

export type OlpnContent = {
  Olpn: string | undefined
  setOlpn: (c: string | undefined) => void
}

export const OlpnContext = createContext<OlpnContent>({
  Olpn: '', // set a default value
  setOlpn: () => { },
})

export const useOlpnContext = () => useContext(OlpnContext)
